import {add_classes, remove_classes} from '../helpers/classlist';

const wrapper = document.querySelector('[data-js-sitewide-ui-notification]');

function show() {
  add_classes(wrapper, 'tff-translate3d-000--active t-active-wrap');
}

function hide() {
  remove_classes(wrapper, 'tff-translate3d-000--active t-active-wrap');
}

function init() {
  window.addEventListener('sitewide-ui-notification/show', show);
  window.addEventListener('sitewide-ui-notification/hide', hide);
}

if (wrapper) {
  init();
}
